import React, { useState } from 'react';
import { Plus, Trash2, ClipboardList } from 'lucide-react';
import { fd, pd } from './calendarLogic';

const newTaskId = () => Math.random().toString(36).slice(2, 10);
const inp = 'px-2 py-1.5 text-sm border border-slate-200 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400';

const TaskForm = ({ orderId, onAdd, onCancel }) => {
  const [fecha, setFecha] = useState('');
  const [desc, setDesc] = useState('');
  const submit = (e) => {
    e.preventDefault();
    if (!fecha || !desc.trim()) return;
    onAdd({ id: newTaskId(), fecha, desc: desc.trim(), hecha: false });
  };
  return (
    <form onSubmit={submit} className="flex flex-wrap gap-2 p-3 bg-indigo-50/50 border border-indigo-100 rounded-lg animate-in fade-in slide-in-from-top-1">
      <input type="date" required data-testid={`task-fecha-${orderId}`} value={fecha} onChange={(e) => setFecha(e.target.value)} className={inp} />
      <input required data-testid={`task-desc-${orderId}`} value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="Descripción de la tarea" className={`${inp} flex-1 min-w-[180px]`} />
      <button type="submit" data-testid={`task-save-${orderId}`} className="px-3 py-1.5 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-colors">Agregar</button>
      <button type="button" onClick={onCancel} className="px-3 py-1.5 rounded-lg text-slate-600 hover:bg-white text-sm font-semibold transition-colors">Cancelar</button>
    </form>
  );
};

export const TaskList = ({ o, today, onChange }) => {
  const [adding, setAdding] = useState(false);
  const tareas = [...(o.tareas || [])].sort((a, b) => a.fecha.localeCompare(b.fecha));
  const set = (list) => onChange(list);
  const toggle = (id, v) => set((o.tareas || []).map((t) => (t.id === id ? { ...t, hecha: v } : t)));
  const del = (id) => set((o.tareas || []).filter((t) => t.id !== id));
  return (
    <div className="mt-4 pt-4 border-t border-slate-100" data-testid={`tareas-${o.id}`}>
      <div className="flex items-center justify-between mb-2">
        <h4 className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-slate-500"><ClipboardList size={14} /> Tareas ({tareas.filter((t) => !t.hecha).length} {tareas.filter((t) => !t.hecha).length === 1 ? 'pendiente' : 'pendientes'})</h4>
        {!adding ? (
          <button data-testid={`btn-add-task-${o.id}`} onClick={() => setAdding(true)} className="inline-flex items-center gap-1 px-2.5 py-1 rounded-lg text-sm font-semibold text-indigo-600 hover:bg-indigo-50 transition-colors"><Plus size={14} /> Agregar tarea</button>
        ) : null}
      </div>
      {adding ? <TaskForm orderId={o.id} onAdd={(t) => { set([...(o.tareas || []), t]); setAdding(false); }} onCancel={() => setAdding(false)} /> : null}
      <div className="space-y-1 mt-1">
        {tareas.map((t) => {
          const late = !t.hecha && t.fecha < today, hoy = !t.hecha && t.fecha === today;
          return (
            <div key={t.id} data-testid={`task-row-${t.id}`} className={`group flex items-center gap-3 px-3 py-2 rounded-lg transition-colors ${late ? 'bg-red-50/60 text-red-700' : hoy ? 'bg-amber-50/60 text-amber-800' : 'text-slate-700 hover:bg-slate-50'}`}>
              <input type="checkbox" data-testid={`task-check-${t.id}`} checked={!!t.hecha} onChange={(e) => toggle(t.id, e.target.checked)} className="w-4 h-4 accent-violet-600 cursor-pointer" />
              <span className={`flex-1 text-sm ${t.hecha ? 'line-through opacity-60' : 'font-medium'}`}>{t.desc}</span>
              <span className="text-xs font-mono">{late ? 'Vencida · ' : hoy ? 'Hoy · ' : ''}{fd(pd(t.fecha))}</span>
              <button data-testid={`task-delete-${t.id}`} onClick={() => del(t.id)} className="p-1 rounded text-slate-400 hover:text-red-600 hover:bg-red-50 opacity-60 group-hover:opacity-100 transition-[opacity,color]" title="Eliminar tarea"><Trash2 size={14} /></button>
            </div>
          );
        })}
        {!tareas.length && !adding ? <p className="text-xs text-slate-400 px-3">Sin tareas</p> : null}
      </div>
    </div>
  );
};
